<div class="h-screen flex flex-col">

  <!-- Top Toolbar -->
  <mat-toolbar color="accent" class="app-toolbar flex justify-between items-center flex-shrink-0">
    <div class="flex items-center gap-2">
      <button mat-icon-button (click)="sidenav.toggle()">
        <mat-icon>menu</mat-icon>
      </button>
      <a routerLink="/">
        <img [src]="branding.logoDarkUrl" class="h-14 w-auto" alt="Logo" />
      </a>
    </div>

    <span class="flex items-center gap-2">
      <!-- User Dropdown -->
      <button mat-icon-button [matMenuTriggerFor]="userMenu">
        <mat-icon>account_circle</mat-icon>
      </button>
      <mat-menu #userMenu="matMenu">
        <button mat-menu-item disabled *ngIf="user$ | async as user">
          <mat-icon>person</mat-icon>
          <span>{{ user.email }}</span>
        </button>
        <mat-divider></mat-divider>
        <button mat-menu-item (click)="logout()">
          <mat-icon>logout</mat-icon>
          <span>{{ 'LOGIN.LOGOUT' | translate }}</span>
        </button>
      </mat-menu>
    </span>
  </mat-toolbar>

  <!-- Main Layout with sidenav -->
  <mat-sidenav-container class="flex-1 h-full">

    <!-- Sidebar -->
    <mat-sidenav
      #sidenav
      mode="side"
      opened
      style="width: 14rem; min-width: 14rem; max-width: 16rem;"
      class="bg-app-bg border-r sidebar-sidenav">

      <div class="sidebar-header p-4 font-bold text-lg border-b">
        {{ 'NAV.TITLE' | translate }}
      </div>

      <div class="sidebar-menu">
        <mat-nav-list>
          <a
            *ngFor="let item of navItems"
            mat-list-item
            [routerLink]="item.route"
            routerLinkActive="active-link"
            (click)="false">
            <mat-icon matListItemIcon class="!mr-2 !text-inherit">{{ item.icon }}</mat-icon>
            {{ item.label | translate }}
          </a>
        </mat-nav-list>
      </div>

      <div class="sidebar-version">
        <div>v{{ version }}</div>
      </div>

    </mat-sidenav>

    <!-- Main Content -->
    <mat-sidenav-content class="overflow-auto p-6 bg-app-bg relative">
      <app-loader></app-loader>
      <router-outlet></router-outlet>
    </mat-sidenav-content>

  </mat-sidenav-container>
</div>
